import MuiDrawer from '@mui/material/Drawer';
import styled from '@emotion/styled';

export const OPEN_DRAWER_WIDTH = '300px';
export const CLOSED_DRAWER_WIDTH = '56px';
export const TRANSITION_DURATION = 0.5;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  '& .MuiDrawer-paper': {
    position: 'relative',
    width: open ? OPEN_DRAWER_WIDTH : CLOSED_DRAWER_WIDTH,
    transition: `all ${TRANSITION_DURATION}s ease-in-out`, //width and margin transitions
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    visibility: 'visible !important',
    transform: 'unset !important',
  },
  ...(!open && {
    '& .sidebar-scroll': {
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  }),
}));

export default Drawer;
